export enum FilterInputType {
  None,
  String,
  Tag,
  Date,
  Float,
  Boolean,
  Integer,
  MultiString,
  MultiTag,
  Custom,
}

export interface ScoringDefinitionValidationOpts {
  minContribution?: number;
  maxContribution?: number;
}
